// ============================================
// BLOG METADATA INDEX
// Tüm blog yazılarının hafif metadata'sı
// Liste sayfası için - içerik yok (lazy load edilecek)
// ============================================

import { BlogMetadata } from '../types';

export const blogMetadata: BlogMetadata[] = [
  {
    id: "0",
    slug: "google-ads-temel-rehber",
    title: "Google Ads Temel Rehberi: Başlangıçtan Uzmanlığa Tam Kılavuz",
    seoTitle: "Google Ads Rehber - Başlangıç Kılavuzu 2025",
    metaDescription: "Google Ads başlangıç rehberi! Hesap açma, kampanya kurulumu, anahtar kelime seçimi ve bütçe yönetimi. 18 yıllık uzman rehberliği.",
    excerpt: "Google Ads dünyasına adım atmak isteyenler için kapsamlı başlangıç rehberi. Kampanya oluşturma, anahtar kelime seçimi ve bütçe yönetimi.",
    coverImage: "/images/blog/google-ads-uzmani.jpg",
    author: {
      name: "Dijital Mustafa",
      avatar: "/images/mustafa-kaya-profil.png",
      title: "Google Ads Uzmanı - 18 Yıl Deneyim"
    },
    publishedAt: "2025-10-25",
    readTime: "15 dakika",
    category: "Google Ads Stratejileri",
    tags: ["Google Ads", "Başlangıç", "Kampanya Kurulumu", "Anahtar Kelime", "Bütçe Yönetimi"]
  },
  {
    id: "1",
    slug: "google-da-reklam-verme",
    title: "Google'da Reklam Verme: Başlangıç Rehberi 2025",
    seoTitle: "Google'da Reklam Verme - Tam Rehber 2025",
    metaDescription: "Google'da reklam verme sürecini adım adım öğrenin. Hesap açma, kampanya kurulumu, bütçe planlaması ve başarı metrikleri.",
    excerpt: "Google'da reklam vermeye nasıl başlanır? Kampanya kurulumundan optimizasyona kadar detaylı rehber.",
    coverImage: "/images/blog/google-da-reklam-verme.jpg",
    author: {
      name: "Dijital Mustafa",
      avatar: "/images/mustafa-kaya-profil.png",
      title: "Google Ads Uzmanı - 18 Yıl Deneyim"
    },
    publishedAt: "2025-10-25",
    readTime: "12 dakika",
    category: "Google Ads Stratejileri",
    tags: ["Google Reklam", "Kampanya Kurulumu", "Başlangıç", "Bütçe Planlaması"]
  },
  {
    id: "2",
    slug: "google-reklam-ajansi",
    title: "Google Reklam Ajansı mı, Bireysel Uzman mı? Doğru Seçim Rehberi",
    seoTitle: "Google Reklam Ajansı vs Uzman - Detaylı Karşılaştırma 2025",
    metaDescription: "Google reklam ajansı mı yoksa bireysel uzman mı? Maliyet analizi, hizmet kalitesi, ROI karşılaştırması ve 2025 seçim kriterleri. Bilinçli karar verin!",
    excerpt: "Google reklam ajansı ile bireysel uzman arasındaki farkları, detaylı maliyet analizi, hizmet kalitesi karşılaştırması ve işletme büyüklüğüne göre önerilerle keşfedin.",
    coverImage: "/images/blog/google-reklam-ajansi-vs-uzman.jpg",
    author: {
      name: "Dijital Mustafa",
      avatar: "/images/mustafa-kaya-profil.png",
      title: "Google Ads Uzmanı - 18 Yıl Deneyim"
    },
    publishedAt: "2025-10-26",
    readTime: "18 dakika",
    category: "Google Ads Danışmanlığı",
    tags: ["Google Reklam Ajansı", "Dijital Ajans", "Google Ads Uzmanı", "Ajans Karşılaştırması", "ROI", "Maliyet Analizi"]
  },
  {
    id: "3",
    slug: "google-ads-reklam-verme",
    title: "Google Ads Reklam Verme: Başarılı Kampanya Stratejileri 2025",
    seoTitle: "Google Ads Reklam Verme - Başarı Stratejileri 2025",
    metaDescription: "Google Ads reklam verme stratejileri ve ipuçları. Kampanya optimizasyonu, hassas hedefleme ve ROI artırma teknikleri. Uzman rehberliği.",
    excerpt: "Google Ads'te etkili reklam verme stratejilerini, hassas hedefleme tekniklerini ve ROI artırma yöntemlerini öğrenin. Kampanya optimizasyonu ve bütçe yönetimi.",
    coverImage: "/images/blog/google-ads-kampanya-performans.jpg",
    author: {
      name: "Dijital Mustafa",
      avatar: "/images/mustafa-kaya-profil.png",
      title: "Google Ads Uzmanı - 18 Yıl Deneyim"
    },
    publishedAt: "2025-10-26",
    readTime: "13 dakika",
    category: "Google Ads Stratejileri",
    tags: ["Google Ads", "Reklam Stratejileri", "Kampanya Optimizasyonu", "ROI", "Hedefleme"]
  },
  {
    id: "4",
    slug: "ads-reklam-verme",
    title: "ADS Reklam Verme: Kapsamlı Başlangıç Rehberi 2025",
    seoTitle: "ADS Reklam Verme - Kapsamlı Rehber 2025",
    metaDescription: "ADS reklam verme stratejileri, kampanya tipleri, bütçe yönetimi, hedefleme teknikleri ve 2025-2026 trendleri. Profesyonel rehberlik ile ROI artışı.",
    excerpt: "ADS ile reklam verme sürecini detaylıca öğrenin. Kampanya tipleri, bütçe planlaması, hedefleme stratejileri, optimizasyon ipuçları ve güncel trendler.",
    coverImage: "/images/blog/ads-kampanya-yonetimi.jpg",
    author: {
      name: "Dijital Mustafa",
      avatar: "/images/mustafa-kaya-profil.png",
      title: "Google Ads Uzmanı - 18 Yıl Deneyim"
    },
    publishedAt: "2025-10-26",
    readTime: "19 dakika",
    category: "Google Ads Stratejileri",
    tags: ["ADS", "Dijital Reklam", "Kampanya Yönetimi", "Bütçe Optimizasyonu", "Hedefleme", "2025 Trendleri"]
  },
  {
    id: "5",
    slug: "google-ads-danismani",
    title: "Google Ads Danışmanı: Profesyonel Destek ile ROI'nizi 3X Artırın",
    seoTitle: "Google Ads Danışmanı - Uzman Rehberlik 2025",
    metaDescription: "Google Ads danışmanı ile çalışmanın avantajları, seçim kriterleri ve maliyet analizi. 18 yıllık deneyimle profesyonel danışmanlık.",
    excerpt: "Google Ads danışmanının rolü, seçim kriterleri ve işletmenize katabileceği değeri keşfedin. Uzman rehberliği ile başarı!",
    coverImage: "/images/blog/google-ads-danismani.jpg",
    author: {
      name: "Dijital Mustafa",
      avatar: "/images/mustafa-kaya-profil.png",
      title: "Google Ads Uzmanı - 18 Yıl Deneyim"
    },
    publishedAt: "2025-10-26",
    readTime: "14 dakika",
    category: "Google Ads Danışmanlığı",
    tags: ["Google Ads Danışmanı", "Dijital Danışmanlık", "ROI", "Kampanya Yönetimi"]
  },
  {
    id: "6",
    slug: "google-ads-ajansi",
    title: "Google Ads Ajansı Seçim Rehberi: En İyi Ajansı Nasıl Bulursunuz?",
    seoTitle: "Google Ads Ajansı Seçim Rehberi - 2025",
    metaDescription: "Google Ads ajansı nasıl seçilir? Fiyatlandırma, hizmetler ve referans kontrolü. Doğru ajans ile ROI artışı garantisi.",
    excerpt: "Google Ads ajansı seçim kriterleri, hizmet paketleri ve fiyatlandırma modelleri. Doğru ajansı seçerek ROI'nizi artırın.",
    coverImage: "/images/blog/google-ads-ajansi.jpg",
    author: {
      name: "Dijital Mustafa",
      avatar: "/images/mustafa-kaya-profil.png",
      title: "Google Ads Uzmanı - 18 Yıl Deneyim"
    },
    publishedAt: "2025-10-26",
    readTime: "18 dakika",
    category: "Google Ads Danışmanlığı",
    tags: ["Google Ads Ajansı", "Ajans Seçimi", "Hizmet Paketleri", "Fiyatlandırma", "ROI"]
  },
  {
    id: "7",
    slug: "google-reklam-uzmani",
    title: "Google Reklam Uzmanı: Yetkinlikler, Seçim ve İş Süreçleri 2025",
    seoTitle: "Google Reklam Uzmanı - Seçim Rehberi 2025",
    metaDescription: "Google reklam uzmanı yetkinlikleri, seçim kriterleri, maliyet analizi ve başarı hikayeleri. Profesyonel rehberlik ile ROI artışı.",
    excerpt: "Google reklam uzmanı seçim kriterleri, gerekli yetkinlikler ve çalışma süreçleri. Doğru uzmanla ROI'nizi maksimize edin.",
    coverImage: "/images/blog/google-reklam-uzmani.jpg",
    author: {
      name: "Dijital Mustafa",
      avatar: "/images/mustafa-kaya-profil.png",
      title: "Google Ads Uzmanı - 18 Yıl Deneyim"
    },
    publishedAt: "2025-10-26",
    readTime: "23 dakika",
    category: "Google Ads Danışmanlığı",
    tags: ["Google Reklam Uzmanı", "Uzman Seçimi", "Yetkinlikler", "İş Süreçleri", "ROI"]
  },
  {
    id: "8",
    slug: "google-ads-ajans",
    title: "Google Ads Ajans Hizmetleri: Paketler, Fiyatlar ve ROI Beklentisi",
    seoTitle: "Google Ads Ajans Hizmetleri - 2025 Paket Rehberi",
    metaDescription: "Google Ads ajans hizmet paketleri, fiyatlandırma modelleri ve ROI beklentileri. Doğru paketi seçerek yatırımınızı maksimize edin.",
    excerpt: "Google Ads ajans hizmet paketleri, fiyatlandırma ve seçim kriterleri. En uygun paketi bulun ve ROI'nizi artırın.",
    coverImage: "/images/blog/google-ads-ajans.jpg",
    author: {
      name: "Dijital Mustafa",
      avatar: "/images/mustafa-kaya-profil.png",
      title: "Google Ads Uzmanı - 18 Yıl Deneyim"
    },
    publishedAt: "2025-10-26",
    readTime: "17 dakika",
    category: "Google Ads Danışmanlığı",
    tags: ["Google Ads Ajans", "Hizmet Paketleri", "Fiyatlandırma", "ROI", "Ajans Karşılaştırması"]
  },
  {
    id: "9",
    slug: "ads-uzmani",
    title: "ADS Uzmanı ile Çalışmanın 10 Büyük Avantajı",
    seoTitle: "ADS Uzmanı ile Çalışmanın 10 Büyük Avantajı | ROI Artışı 2025",
    metaDescription: "ADS uzmanı ile çalışmanın 10 büyük avantajı, ROI artışı stratejileri ve başarı hikayeleri. Profesyonel Google Ads yönetimi ile kazancınızı %300 artırın.",
    excerpt: "ADS uzmanı ile çalışarak kampanyalarınızda elde edeceğiniz 10 büyük avantaj, ROI artışı ve profesyonel yönetim rehberi.",
    coverImage: "/images/blog/ads-uzmani.jpg",
    author: {
      name: "Dijital Mustafa",
      avatar: "/images/mustafa-kaya-profil.png",
      title: "Google Ads Uzmanı - 18 Yıl Deneyim"
    },
    publishedAt: "2025-10-26",
    readTime: "15 dakika",
    category: "Google Ads Danışmanlığı",
    tags: ["ADS Uzmanı", "ROI Artışı", "Profesyonel Yönetim", "Google Ads Danışmanlığı", "Kampanya Optimizasyonu"]
  },
  {
    id: "10",
    slug: "google-ads-uzmani",
    title: "Google Ads Uzmanı: Nasıl Seçilir ve Neden Gereklidir?",
    seoTitle: "Google Ads Uzmanı Seçimi - 2025 Rehberi",
    metaDescription: "Google Ads uzmanı seçim kriterleri, sertifikalar, deneyim ve maliyet analizi. 18 yıllık uzman perspektifiyle profesyonel destek rehberi.",
    excerpt: "Google Ads uzmanı seçerken nelere dikkat edilmeli? Sertifikalar, deneyim, referanslar ve maliyet analizi.",
    coverImage: "/images/blog/google-ads-uzmani.jpg",
    author: {
      name: "Dijital Mustafa",
      avatar: "/images/mustafa-kaya-profil.png",
      title: "Google Ads Uzmanı - 18 Yıl Deneyim"
    },
    publishedAt: "2025-10-26",
    readTime: "22 dakika",
    category: "Google Ads Danışmanlığı",
    tags: ["Google Ads Uzmanı", "Uzman Seçimi", "Sertifikalar", "ROI", "Dijital Pazarlama", "Reklam Yönetimi"]
  },
  {
    id: "11",
    slug: "google-ads-danismanligi",
    title: "Google Ads Danışmanlığı: Profesyonel Destek ile ROI Artışı",
    seoTitle: "Google Ads Danışmanlığı - Uzman Rehberlik 2025",
    metaDescription: "Google Ads danışmanlık hizmetleri, paketler, fiyatlandırma ve ROI artışı. 18 yıllık uzman ile kampanyalarınızı optimize edin.",
    excerpt: "Google Ads danışmanlık hizmetleri neler sunar? Paket seçenekleri, fiyatlar ve ROI artışı stratejileri.",
    coverImage: "/images/blog/google-ads-danismanligi.jpg",
    author: {
      name: "Dijital Mustafa",
      avatar: "/images/mustafa-kaya-profil.png",
      title: "Google Ads Uzmanı - 18 Yıl Deneyim"
    },
    publishedAt: "2025-10-26",
    readTime: "13 dakika",
    category: "Google Ads Danışmanlığı",
    tags: ["Google Ads Danışmanlığı", "Danışmanlık Paketleri", "ROI Artışı", "Profesyonel Destek"]
  },
  {
    id: "12",
    slug: "google-haritalarda-reklam-verme",
    title: "Google Haritalarda Reklam Verme: Yerel İşletmeler İçin Tam Rehber",
    seoTitle: "Google Haritalarda Reklam Verme - 2025 Rehberi",
    metaDescription: "Google Haritalarda reklam verme stratejileri, kampanya kurulumu, maliyet hesaplama ve optimizasyon. Yerel işletmeler için detaylı kılavuz.",
    excerpt: "Google Haritalarda nasıl reklam verilir? Yerel işletmeler için kampanya kurulumu ve optimizasyon stratejileri.",
    coverImage: "/images/blog/google-haritalarda-reklam-verme.jpg",
    author: {
      name: "Dijital Mustafa",
      avatar: "/images/mustafa-kaya-profil.png",
      title: "Google Ads Uzmanı - 18 Yıl Deneyim"
    },
    publishedAt: "2025-10-27",
    readTime: "16 dakika",
    category: "Google Haritalar & Yerel SEO",
    tags: ["Google Haritalar", "Yerel Reklam", "Google Maps", "İşletme Profili", "Kampanya Kurulumu"]
  },
  {
    id: "13",
    slug: "google-da-reklam-vermek-istiyorum",
    title: "Google'da Reklam Vermek İstiyorum: Başlangıç Adımları 2025",
    seoTitle: "Google'da Reklam Vermek İstiyorum - İlk Adımlar",
    metaDescription: "Google'da reklam vermek istiyorum diyenlere özel başlangıç rehberi. Hesap açma, kampanya kurulumu, bütçe belirleme ve ilk adımlar.",
    excerpt: "Google'da reklam vermeye nasıl başlanır? Sıfırdan kampanya kurulumu ve başarılı olma stratejileri.",
    coverImage: "/images/blog/google-da-reklam-vermek-istiyorum.jpg",
    author: {
      name: "Dijital Mustafa",
      avatar: "/images/mustafa-kaya-profil.png",
      title: "Google Ads Uzmanı - 18 Yıl Deneyim"
    },
    publishedAt: "2025-10-25",
    readTime: "14 dakika",
    category: "Google Ads Stratejileri",
    tags: ["Google Reklam", "İlk Adımlar", "Başlangıç Rehberi", "Kampanya Kurulumu", "Bütçe Belirleme"]
  },
  {
    id: "14",
    slug: "google-reklam-reklam-ajanslari",
    title: "Google Reklam Ajansları: Türkiye'nin En İyi 10 Ajansı 2026",
    seoTitle: "Google Reklam Ajansları 2026 - Türkiye'nin En İyi 10 Ajansı",
    metaDescription: "Google reklam ajansları 2026 karşılaştırması: Türkiye'nin en iyi 10 ajansı, hizmet paketleri, fiyatlandırma, Google Partner sertifikaları ve seçim kriterleri rehberi.",
    excerpt: "Google reklam ajansı nasıl seçilir? 2026 yılında Türkiye'nin önde gelen 10 ajansının karşılaştırması, fiyatlandırma ve detaylı seçim rehberi.",
    coverImage: "/images/blog/google-reklam-ajanslari.jpg",
    author: {
      name: "Dijital Mustafa",
      avatar: "/images/mustafa-kaya-profil.png",
      title: "Google Ads Uzmanı - 18 Yıl Deneyim"
    },
    publishedAt: "2026-06-19",
    readTime: "18 dakika",
    category: "Google Ads Danışmanlığı",
    tags: ["Reklam Ajansları", "Ajans Karşılaştırması", "Seçim Kriterleri", "Fiyatlandırma", "En İyi Ajanslar"]
  },
  {
    id: "15",
    slug: "ads-reklam-uzmani",
    title: "ADS Reklam Uzmanı Seçimi: 2025 Kriterleri ve Maliyet Analizi",
    seoTitle: "ADS Reklam Uzmanı - Seçim Rehberi 2025",
    metaDescription: "ADS reklam uzmanı nasıl seçilir? Sertifikalar, deneyim, referanslar ve maliyet analizi. Doğru uzmanla ROI'nizi 3X artırın.",
    excerpt: "ADS reklam uzmanı seçerken dikkat edilmesi gerekenler. Sertifikalar, deneyim ve başarı kriterleri rehberi.",
    coverImage: "/images/blog/ads-reklam-uzmani.jpg",
    author: {
      name: "Dijital Mustafa",
      avatar: "/images/mustafa-kaya-profil.png",
      title: "Google Ads Uzmanı - 18 Yıl Deneyim"
    },
    publishedAt: "2025-10-27",
    readTime: "14 dakika",
    category: "Google Ads Danışmanlığı",
    tags: ["ADS Uzmanı", "Uzman Seçimi", "Google Ads", "Dijital Pazarlama"]
  },
  {
    id: "16",
    slug: "google-harita-reklam-verme",
    title: "Google Harita Reklam Verme: Yerel İşletmeler İçin Stratejiler",
    seoTitle: "Google Harita Reklam Verme - Yerel İşletme Rehberi",
    metaDescription: "Google Harita reklam verme stratejileri, kampanya tipleri, optimizasyon ve ROI artırma. Yerel işletmeler için detaylı rehber.",
    excerpt: "Google Harita'da reklam vererek yerel müşterilere ulaşın. Kampanya kurulumu ve optimizasyon stratejileri.",
    coverImage: "/images/blog/google-harita-reklam-verme.jpg",
    author: {
      name: "Dijital Mustafa",
      avatar: "/images/mustafa-kaya-profil.png",
      title: "Google Ads Uzmanı - 18 Yıl Deneyim"
    },
    publishedAt: "2025-10-27",
    readTime: "15 dakika",
    category: "Google Haritalar & Yerel SEO",
    tags: ["Google Harita", "Yerel Reklam", "Kampanya Optimizasyonu", "İşletme Profili"]
  },
  {
    id: "17",
    slug: "google-haritalara-reklam-vermek",
    title: "Google Haritalara Reklam Vermek: Adım Adım Kurulum Rehberi",
    seoTitle: "Google Haritalara Reklam Vermek - Kurulum Rehberi",
    metaDescription: "Google Haritalara reklam vermek için gerekli adımlar, hesap kurulumu, kampanya ayarları ve başarı metrikleri.",
    excerpt: "Google Haritalara nasıl reklam verilir? Detaylı kurulum süreci ve ilk kampanya stratejileri.",
    coverImage: "/images/blog/google-haritalara-reklam-vermek.jpg",
    author: {
      name: "Dijital Mustafa",
      avatar: "/images/mustafa-kaya-profil.png",
      title: "Google Ads Uzmanı - 18 Yıl Deneyim"
    },
    publishedAt: "2025-10-28",
    readTime: "13 dakika",
    category: "Google Haritalar & Yerel SEO",
    tags: ["Google Haritalar", "Reklam Verme", "Kurulum Rehberi", "Yerel Kampanya"]
  },
  {
    id: "18",
    slug: "google-maps-reklam-verme",
    title: "Google Maps Reklam Verme: Kampanya Stratejileri ve Optimizasyon",
    seoTitle: "Google Maps Reklam Verme - Stratejiler 2025",
    metaDescription: "Google Maps reklam verme kampanya tipleri, hedefleme, bütçe yönetimi ve optimizasyon stratejileri. Detaylı rehber.",
    excerpt: "Google Maps'te etkili reklam kampanyaları oluşturun. Hedefleme ve optimizasyon stratejileri.",
    coverImage: "/images/blog/google-maps-reklam-verme.jpg",
    author: {
      name: "Dijital Mustafa",
      avatar: "/images/mustafa-kaya-profil.png",
      title: "Google Ads Uzmanı - 18 Yıl Deneyim"
    },
    publishedAt: "2025-10-27",
    readTime: "16 dakika",
    category: "Google Haritalar & Yerel SEO",
    tags: ["Google Maps", "Reklam Kampanyası", "Optimizasyon", "Hedefleme Stratejileri"]
  },
  {
    id: "19",
    slug: "google-ilan-verme",
    title: "Google İlan Verme: Tüm Kampanya Türleri ve Stratejileri 2025",
    seoTitle: "Google İlan Verme - Kampanya Rehberi 2025",
    metaDescription: "Google ilan verme türleri, kampanya seçenekleri, maliyet hesaplama ve başarı stratejileri. Kapsamlı rehber.",
    excerpt: "Google'da ilan vermek için bilmeniz gereken her şey. Kampanya türleri ve başarı stratejileri.",
    coverImage: "/images/blog/google-ilan-verme.jpg",
    author: {
      name: "Dijital Mustafa",
      avatar: "/images/mustafa-kaya-profil.png",
      title: "Google Ads Uzmanı - 18 Yıl Deneyim"
    },
    publishedAt: "2025-10-28",
    readTime: "14 dakika",
    category: "Google Ads Stratejileri",
    tags: ["Google İlan", "Kampanya Türleri", "Reklam Stratejileri", "Maliyet Hesaplama"]
  },
  {
    id: "20",
    slug: "google-partner-ajanslari",
    title: "Google Partner Ajansları: Seçim Kriterleri ve Avantajlar 2025",
    seoTitle: "Google Partner Ajansları - Seçim Rehberi",
    metaDescription: "Google Partner ajansları nedir? Seçim kriterleri, avantajlar, fiyatlandırma ve referans kontrolü. Doğru ajansı bulun.",
    excerpt: "Google Partner ajansı ile çalışmanın avantajları ve doğru ajans seçim kriterleri.",
    coverImage: "/images/blog/google-partner-ajanslari.jpg",
    author: {
      name: "Dijital Mustafa",
      avatar: "/images/mustafa-kaya-profil.png",
      title: "Google Ads Uzmanı - 18 Yıl Deneyim"
    },
    publishedAt: "2025-10-27",
    readTime: "18 dakika",
    category: "Google Ads Danışmanlığı",
    tags: ["Google Partner", "Partner Ajansları", "Seçim Kriterleri", "Ajans Avantajları"]
  },
  {
    id: "21",
    slug: "google-partner-ajans",
    title: "Google Partner Ajans ile Çalışmak: Hizmetler ve Maliyetler",
    seoTitle: "Google Partner Ajans - Hizmetler ve Maliyetler",
    metaDescription: "Google Partner ajans hizmet kapsamı, ücretlendirme modelleri, sözleşme ipuçları ve ROI beklentisi. Detaylı analiz.",
    excerpt: "Google Partner ajans ile çalışmanın detayları. Hizmet paketleri, maliyetler ve sözleşme maddeleri.",
    coverImage: "/images/blog/google-partner-ajans.jpg",
    author: {
      name: "Dijital Mustafa",
      avatar: "/images/mustafa-kaya-profil.png",
      title: "Google Ads Uzmanı - 18 Yıl Deneyim"
    },
    publishedAt: "2025-10-28",
    readTime: "16 dakika",
    category: "Google Ads Danışmanlığı",
    tags: ["Partner Ajans", "Hizmet Paketleri", "Maliyetler", "Sözleşme"]
  },
  {
    id: "22",
    slug: "ads-reklam-ajansi",
    title: "ADS Reklam Ajansı ile Çalışmak: Seçim Checklist ve İpuçları",
    seoTitle: "ADS Reklam Ajansı - Seçim Checklist 2025",
    metaDescription: "ADS reklam ajansı seçerken dikkat edilmesi gerekenler, 15 maddelik checklist ve maliyet hesaplama. Doğru ajansı bulmanın formülü.",
    excerpt: "ADS ajansı seçiminde kritik checklist, maliyet hesaplama ve sözleşme ipuçları. Hata yapmadan doğru ajansı bulun.",
    coverImage: "/images/blog/ads-reklam-ajansi.jpg",
    author: {
      name: "Dijital Mustafa",
      avatar: "/images/mustafa-kaya-profil.png",
      title: "Google Ads Uzmanı - 18 Yıl Deneyim"
    },
    publishedAt: "2025-10-28",
    readTime: "12 dakika",
    category: "Google Ads Danışmanlığı",
    tags: ["ADS Ajansı", "Seçim Checklist", "Maliyet", "Sözleşme", "İpuçları"]
  },
  {
    id: "23",
    slug: "google-isletme-reklam-verme",
    title: "Google İşletme Reklam Verme: İşletme Profili Optimizasyonu",
    seoTitle: "Google İşletme Reklam Verme - Profil Optimizasyonu",
    metaDescription: "Google İşletme Profili ile reklam verme stratejileri, profil optimizasyonu, yerel SEO ve kampanya entegrasyonu.",
    excerpt: "Google İşletme Profili ile yerel müşterilere ulaşın. Profil optimizasyonu ve reklam stratejileri.",
    coverImage: "/images/blog/google-isletme-reklam-verme.jpg",
    author: {
      name: "Dijital Mustafa",
      avatar: "/images/mustafa-kaya-profil.png",
      title: "Google Ads Uzmanı - 18 Yıl Deneyim"
    },
    publishedAt: "2025-10-27",
    readTime: "14 dakika",
    category: "Google Haritalar & Yerel SEO",
    tags: ["Google İşletme", "Profil Optimizasyonu", "Yerel SEO", "Kampanya Entegrasyonu"]
  },
  {
    id: "24",
    slug: "google-harita-seo",
    title: "Google Harita SEO: Yerel Arama Optimizasyonu Rehberi 2025",
    seoTitle: "Google Harita SEO - Yerel Optimizasyon 2025",
    metaDescription: "Google Harita SEO stratejileri, yerel sıralama faktörleri, işletme profili optimizasyonu ve trafik artırma teknikleri.",
    excerpt: "Google Harita SEO ile yerel aramada üst sıralarda yer alın. Optimizasyon stratejileri ve ipuçları.",
    coverImage: "/images/blog/google-harita-seo.jpg",
    author: {
      name: "Dijital Mustafa",
      avatar: "/images/mustafa-kaya-profil.png",
      title: "Google Ads Uzmanı - 18 Yıl Deneyim"
    },
    publishedAt: "2025-10-28",
    readTime: "17 dakika",
    category: "Google Haritalar & Yerel SEO",
    tags: ["Harita SEO", "Yerel SEO", "Sıralama Faktörleri", "Profil Optimizasyonu"]
  },
  {
    id: "25",
    slug: "harita-seo",
    title: "Harita SEO: Yerel İşletmeler İçin Kapsamlı Optimizasyon Rehberi",
    seoTitle: "Harita SEO - Yerel İşletme Optimizasyonu",
    metaDescription: "Harita SEO nedir? Yerel sıralama stratejileri, Google İşletme Profili optimizasyonu ve trafik artırma teknikleri.",
    excerpt: "Harita SEO ile yerel aramada görünürlüğünüzü artırın. Detaylı optimizasyon rehberi.",
    coverImage: "/images/blog/harita-seo.jpg",
    author: {
      name: "Dijital Mustafa",
      avatar: "/images/mustafa-kaya-profil.png",
      title: "Google Ads Uzmanı - 18 Yıl Deneyim"
    },
    publishedAt: "2025-10-28",
    readTime: "15 dakika",
    category: "Google Haritalar & Yerel SEO",
    tags: ["Harita SEO", "Yerel İşletme", "Optimizasyon", "Görünürlük Artırma"]
  },
  {
    id: "26",
    slug: "reklam-verme-google",
    title: "Reklam Verme Google: Platform Özellikleri ve Kampanya Türleri",
    seoTitle: "Reklam Verme Google - Platform Rehberi 2025",
    metaDescription: "Google'da reklam verme platformu özellikleri, kampanya türleri, hedefleme seçenekleri ve başarı stratejileri.",
    excerpt: "Google reklam verme platformunun tüm özellikleri. Kampanya türleri ve başarı stratejileri.",
    coverImage: "/images/blog/reklam-verme-google.jpg",
    author: {
      name: "Dijital Mustafa",
      avatar: "/images/mustafa-kaya-profil.png",
      title: "Google Ads Uzmanı - 18 Yıl Deneyim"
    },
    publishedAt: "2025-10-27",
    readTime: "13 dakika",
    category: "Google Ads Stratejileri",
    tags: ["Google Reklam", "Platform Özellikleri", "Kampanya Türleri", "Hedefleme"]
  },
  {
    id: "27",
    slug: "ads-danismanligi",
    title: "ADS Danışmanlığı: Profesyonel Destek ve Hizmet Paketleri 2025",
    seoTitle: "ADS Danışmanlığı - Profesyonel Destek 2025",
    metaDescription: "ADS danışmanlık hizmetleri, paket seçenekleri, ücretlendirme modelleri ve ROI stratejileri. Uzman desteğiyle başarı.",
    excerpt: "ADS danışmanlığı ile kampanyalarınızı optimize edin. Hizmet paketleri ve başarı stratejileri.",
    coverImage: "/images/blog/ads-danismanligi.jpg",
    author: {
      name: "Dijital Mustafa",
      avatar: "/images/mustafa-kaya-profil.png",
      title: "Google Ads Uzmanı - 18 Yıl Deneyim"
    },
    publishedAt: "2025-10-28",
    readTime: "14 dakika",
    category: "Google Ads Danışmanlığı",
    tags: ["ADS Danışmanlığı", "Profesyonel Destek", "Hizmet Paketleri", "ROI Stratejileri"]
  },
  {
    id: "28",
    slug: "internet-reklam-verme",
    title: "İnternet Reklam Verme: Dijital Reklamcılık Stratejileri 2025",
    seoTitle: "İnternet Reklam Verme - Dijital Strateji 2025",
    metaDescription: "İnternet reklam verme kanalları, stratejiler, bütçe planlaması ve ROI maksimizasyonu. Kapsamlı dijital reklamcılık rehberi.",
    excerpt: "İnternet reklam verme stratejileri ve kanalları. Dijital reklamcılıkta başarılı olmanın yolları.",
    coverImage: "/images/blog/internet-reklam-verme.jpg",
    author: {
      name: "Dijital Mustafa",
      avatar: "/images/mustafa-kaya-profil.png",
      title: "Google Ads Uzmanı - 18 Yıl Deneyim"
    },
    publishedAt: "2025-10-28",
    readTime: "16 dakika",
    category: "Dijital Pazarlama & Genel",
    tags: ["İnternet Reklam", "Dijital Reklamcılık", "Reklam Kanalları", "ROI Maksimizasyonu"]
  },
  {
    id: "29",
    slug: "click-fraud-protection",
    title: "Sahte Tıklama Koruması: Google Ads Bütçenizi Nasıl Korursunuz?",
    seoTitle: "Sahte Tıklama Koruması - Google Ads Dolandırıcılık Önleme 2025",
    metaDescription: "Sahte tıklama koruması ile Google Ads bütçenizi %30'a kadar koruyun. Tespit yöntemleri, önleme stratejileri ve en iyi koruma araçları. 18 yıllık uzman rehberi.",
    excerpt: "Google Ads sahte tıklama dolandırıcılığından nasıl korunursunuz? Bot tespiti, IP engelleme ve profesyonel koruma araçları ile bütçenizi %30 koruyun.",
    coverImage: "/images/blog/click-fraud-protection-hero.jpg",
    author: {
      name: "Dijital Mustafa",
      avatar: "/images/mustafa-kaya-profil.png",
      title: "Google Ads Uzmanı - 18 Yıl Deneyim"
    },
    publishedAt: "2025-10-29",
    readTime: "22 dakika",
    category: "Google Ads Optimizasyonu",
    tags: ["Sahte Tıklama Koruması", "Tıklama Dolandırıcılığı", "Click Fraud", "Google Ads Güvenlik", "Bütçe Koruma", "Bot Tespiti"]
  },
  {
    id: "30",
    slug: "keyword-research-2025",
    title: "Keyword Research 2025: Anahtar Kelime Araştırma Rehberi",
    seoTitle: "Keyword Research 2025 - Anahtar Kelime Rehberi",
    metaDescription: "2025 anahtar kelime araştırma stratejileri, araçlar, rekabet analizi ve uzun kuyruk kelimeler. AI destekli rehber.",
    excerpt: "2025'te anahtar kelime araştırması nasıl yapılır? Modern stratejiler ve AI destekli araçlar.",
    coverImage: "/images/blog/keyword-research-2025.jpg",
    author: {
      name: "Dijital Mustafa",
      avatar: "/images/mustafa-kaya-profil.png",
      title: "Google Ads Uzmanı - 18 Yıl Deneyim"
    },
    publishedAt: "2025-10-29",
    readTime: "18 dakika",
    category: "Google Ads Optimizasyonu",
    tags: ["Keyword Research", "Anahtar Kelime", "AI Araçları", "Rekabet Analizi", "Optimizasyon"]
  },
  {
    id: "31",
    slug: "google-adwords-uzmani",
    title: "Google AdWords Uzmanı: Seçim Kriterleri ve Deneyim Doğrulama",
    seoTitle: "Google AdWords Uzmanı - Seçim Rehberi 2025",
    metaDescription: "Google AdWords uzmanı nasıl seçilir? Sertifikalar, deneyim doğrulama, referans kontrolü ve maliyet analizi. Detaylı rehber.",
    excerpt: "Google AdWords uzmanı seçerken dikkat edilmesi gerekenler. Deneyim ve sertifika doğrulama.",
    coverImage: "/images/blog/google-adwords-uzmani.jpg",
    author: {
      name: "Dijital Mustafa",
      avatar: "/images/mustafa-kaya-profil.png",
      title: "Google Ads Uzmanı - 18 Yıl Deneyim"
    },
    publishedAt: "2025-10-27",
    readTime: "22 dakika",
    category: "Google Ads Danışmanlığı",
    tags: ["Google AdWords Uzmanı", "Uzman Seçimi", "Google Partner", "Sertifikalar", "Deneyim Doğrulama"]
  },
  {
    id: "32",
    slug: "adwords-reklam-verme",
    title: "AdWords Reklam Verme: Klasik Platform Rehberi ve Geçiş Stratejileri",
    seoTitle: "AdWords Reklam Verme - Platform Rehberi",
    metaDescription: "AdWords platformunda reklam verme rehberi. Klasik kampanya kurulumu, Google Ads'e geçiş ve veri aktarımı.",
    excerpt: "AdWords platformunda reklam verme. Klasik kampanya kurulumu ve Google Ads geçiş stratejileri.",
    coverImage: "/images/blog/adwords-reklam-verme.jpg",
    author: {
      name: "Dijital Mustafa",
      avatar: "/images/mustafa-kaya-profil.png",
      title: "Google Ads Uzmanı - 18 Yıl Deneyim"
    },
    publishedAt: "2025-10-25",
    readTime: "13 dakika",
    category: "Google Ads Stratejileri",
    tags: ["AdWords", "Klasik Platform", "Google Ads Geçiş", "Veri Aktarımı"]
  },
  {
    id: "33",
    slug: "google-reklam-danismani",
    title: "Google Ads Danışmanı: Profesyonel Destek ile ROI'nizi 3X Artırın",
    seoTitle: "Google Ads Danışmanı: ROI'nizi 3X Artırın - 2025",
    metaDescription: "Google Ads danışmanı ile ROI'nizi %200-400 artırın! 2025 seçim kriterleri, maliyet analizi, Google sertifikaları, çalışma süreci ve trendler. Uzman rehberlik.",
    excerpt: "Google Ads danışmanı seçerken dikkat edilmesi gerekenler: Deneyim kriterleri, Google sertifikaları, maliyet analizi, 2025-2026 trendleri ve ROI artışı stratejileri. Profesyonel destek ile %300 büyüme.",
    coverImage: "/images/blog/google-ads-danisman-toplanti.jpg",
    author: {
      name: "Dijital Mustafa",
      avatar: "/images/mustafa-kaya-profil.png",
      title: "Google Ads Uzmanı - 18 Yıl Deneyim"
    },
    publishedAt: "2025-10-28",
    readTime: "20 dakika",
    category: "Google Ads Danışmanlığı",
    tags: ["Google Ads Danışmanı", "Google Reklam Danışmanlığı", "Sertifikalı Danışman", "ROI Artışı", "Maliyet Analizi", "2025 Trendleri", "Profesyonel Destek"]
  },
  {
    id: "34",
    slug: "google-ads-reklam-uzmani",
    title: "Google Ads Reklam Uzmanı: Yetkinlikler ve Başarı Kriterleri 2025",
    seoTitle: "Google Ads Reklam Uzmanı - Yetkinlikler",
    metaDescription: "Google Ads reklam uzmanı yetkinlikleri, beceriler, sertifikalar ve başarı örnekleri. Detaylı uzman rehberi.",
    excerpt: "Google Ads reklam uzmanı yetkinlikleri ve başarı kriterleri. Uzman seçim rehberi.",
    coverImage: "/images/blog/google-ads-reklam-uzmani.jpg",
    author: {
      name: "Dijital Mustafa",
      avatar: "/images/mustafa-kaya-profil.png",
      title: "Google Ads Uzmanı - 18 Yıl Deneyim"
    },
    publishedAt: "2025-10-26",
    readTime: "14 dakika",
    category: "Google Ads Danışmanlığı",
    tags: ["Google Ads Uzmanı", "Yetkinlikler", "Sertifikalar", "Başarı Kriterleri"]
  },
  {
    id: "35",
    slug: "google-ajansi",
    title: "Google Ajansı Seçimi: Hizmet Kapsamı ve Fiyatlandırma Rehberi",
    seoTitle: "Google Ajansı - Seçim Rehberi 2025",
    metaDescription: "Google ajansı seçim kriterleri, hizmet paketleri, fiyatlandırma ve ROI beklentisi. Doğru ajansı bulun.",
    excerpt: "Google ajansı seçim kriterleri ve hizmet paketleri. Fiyatlandırma ve sözleşme ipuçları.",
    coverImage: "/images/blog/google-ajansi.jpg",
    author: {
      name: "Dijital Mustafa",
      avatar: "/images/mustafa-kaya-profil.png",
      title: "Google Ads Uzmanı - 18 Yıl Deneyim"
    },
    publishedAt: "2025-10-27",
    readTime: "13 dakika",
    category: "Google Ads Danışmanlığı",
    tags: ["Google Ajansı", "Ajans Seçimi", "Hizmet Paketleri", "Fiyatlandırma"]
  },
  {
    id: "36",
    slug: "google-reklam-danismanligi",
    title: "Google Reklam Danışmanlığı: Hizmet Paketleri ve ROI Stratejileri 2025",
    seoTitle: "Google Reklam Danışmanlığı - ROI Stratejileri",
    metaDescription: "Google reklam danışmanlığı hizmet paketleri, süreç adımları, ROI stratejileri ve başarı hikayeleri.",
    excerpt: "Google reklam danışmanlığı hizmet paketleri ve ROI stratejileri. Başarı hikayeleri.",
    coverImage: "/images/blog/google-reklam-danismanligi.jpg",
    author: {
      name: "Dijital Mustafa",
      avatar: "/images/mustafa-kaya-profil.png",
      title: "Google Ads Uzmanı - 18 Yıl Deneyim"
    },
    publishedAt: "2025-10-28",
    readTime: "15 dakika",
    category: "Google Ads Danışmanlığı",
    tags: ["Google Reklam Danışmanlığı", "Hizmet Paketleri", "ROI Stratejileri", "Başarı Hikayeleri"]
  },
  {
    id: "37",
    slug: "google-maps-ads",
    title: "Google Maps Ads: Yerel Reklam Kampanyaları ve Optimizasyon 2025",
    seoTitle: "Google Maps Ads - Yerel Reklam 2025",
    metaDescription: "Google Maps Ads kampanya türleri, kurulum, hedefleme ve optimizasyon. Case study ile desteklenmiş rehber.",
    excerpt: "Google Maps Ads ile yerel müşterilere ulaşın. Kampanya kurulumu ve optimizasyon.",
    coverImage: "/images/blog/google-maps-ads.jpg",
    author: {
      name: "Dijital Mustafa",
      avatar: "/images/mustafa-kaya-profil.png",
      title: "Google Ads Uzmanı - 18 Yıl Deneyim"
    },
    publishedAt: "2025-10-27",
    readTime: "15 dakika",
    category: "Google Haritalar & Yerel SEO",
    tags: ["Google Maps Ads", "Yerel Reklam", "Kampanya Optimizasyonu", "Case Study"]
  }
];

export function getBlogMetadata(slug: string): BlogMetadata | undefined {
  return blogMetadata.find(blog => blog.slug === slug);
}

export function getBlogMetadataByCategory(category: string): BlogMetadata[] {
  return blogMetadata.filter(blog => blog.category === category);
}

export function getAllCategories(): string[] {
  const categories = new Set(blogMetadata.map(blog => blog.category));
  return Array.from(categories);
}
